module.exports = __webpack_public_path__ + "img/olympiad-social-science.dcbead6a.svg";